var window=global;var $CLJS=require("./cljs_env.js");
'use strict';var $fa=require("moment-timezone");module.exports=$fa;